import { filterOperators, filterTypes } from '../../../../../../../../../../../redux/blueprints/search';

const advancedFilters = [
  {
    name: 'codes',
    subProperties: [
      {
        entity: 'code',
        name: 'letter',
        key: 'codes.letter',
        type: filterTypes.enum,
        nestedPath: 'codes',
        operators: [
          filterOperators.isEqualTo
        ]
      },
      {
        entity: 'code',
        name: 'applied on',
        key: 'codes.date',
        nestedPath: 'codes',
        type: filterTypes.date,
        operators: [
          filterOperators.isAfter,
          filterOperators.isBefore
        ]
      }
    ]
  }
];

export default advancedFilters;
